import { useSearchSuggestionsStartTimingForQuery } from "@faire/deprecated-retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/__internal__/useSearchSuggestionsStartTimingForQuery";
import { useSearchSuggestionsQuery } from "@faire/deprecated-retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsQuery";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";

export const useSearchSuggestionsData = () => {
  const { data } = useSearchSuggestionsQuery();

  const query = data?.query;
  const startTimingMarker = useSearchSuggestionsStartTimingForQuery(query);

  return {
    searchSuggestionResponse: ISearchSuggestionResponse.build(data),
    startTimingMarker,
    query,
  };
};
